import { game, user } from '../store/store';
import { apiUrlGet } from './common';
import { sumGameInit } from './session_common'; 
import { MAX_NUM_DEFAULT, LENGTH_DEFAULT } from './constants';

let userSess = '';
let gameSess = '';

user.subscribe((val) => userSess = val);
game.subscribe((val) => gameSess = val);

export async function startGame() {
  console.log("startGame");
}

export async function newGame(playerName, option={}) {
  let boardLength = ('boardLength' in option ? option.boardLength : LENGTH_DEFAULT);
  let maxNum = ('maxNum' in option ? option.maxNum : MAX_NUM_DEFAULT);
  boardLength = parseInt(boardLength);
  maxNum = parseInt(maxNum);
  const gameNewOb = {
    playerName,
    boardLength,
    maxNum,
  };
  await enterGame(gameNewOb);
}

export async function joinGame(playerName, gameCode) {
    const gameJoinOb = {
      playerName,
      gameCode,
    };
    await enterGame(gameJoinOb);
}  

async function enterGame(gameEnterOb) {
    const gameEnterUrl = apiUrlGet("auth/game/login");
    await fetch(gameEnterUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(gameEnterOb),
      credentials: "include",
    });
    await sumGameInit();

}
  
export async function leaveGame() {
  const userId = userSess.id;
  const gameId = gameSess.id;
  const gameLeaveUrl = apiUrlGet(`game/play/${gameId}/leave`);
  const gameLeaveOb = {
    userId,
  };
  await fetch(gameLeaveUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(gameLeaveOb),
    credentials: 'include',
  });
  await sumGameInit();
}
